import { Moon, LunarPhase } from "lunarphase-js";
import Config from '@/config';


export default {
  isMobile() {
    return screen.width < screen.height;
  },

  shiftDate(date, what, count) {
    let res = new Date(date);
    let value = Date.prototype['get'+what].call(res);
    Date.prototype['set'+what].call(res, value + count);
    return res;
  },

  defaultDateRange() {
    let end   = new Date();
    let start = this.shiftDate(end, 'Date', -Config.DEFAULT_API_DAYS);
    return [start, end];
  },

  left_pad(str, char, n) {
    return (str.length >= n) ? str : this.left_pad(char+str, char, n);
  },

  substract_string_start(str1, str2) {
    // "patata"
    // "pataka"
    // → ["ta", "ka"]
    if (str1 && str2 && str1[0] === str2[0])
      return this.substract_string_start(str1.slice(1), str2.slice(1));
    return [str1, str2];
  },

  getMoonPhase(dt) {
    // 0 => New Moon
    // 1 => Waxing Crescent Moon
    // 2 => Quarter Moon
    // 3 => Waxing Gibbous Moon
    // 4 => Full Moon
    // 5 => Waning Gibbous Moon
    // 6 => Last Quarter Moon
    // 7 => Waning Crescent Moon
    const phase = Moon.lunarPhase(dt);
    return ([
      LunarPhase.NEW,
      LunarPhase.WAXING_CRESCENT,
      LunarPhase.FIRST_QUARTER,
      LunarPhase.WAXING_GIBBOUS,
      LunarPhase.FULL,
      LunarPhase.WANING_GIBBOUS,
      LunarPhase.LAST_QUARTER,
      LunarPhase.WANING_CRESCENT,
    ]).indexOf(phase)
  },

  getMoonPhaseMonth(dt) {
    // dt is a Date object, of which year and month will be used.
    // Returns [0, 0, 0, 1, 1, 1, ...] where each position is a day.
    let year  = dt.getFullYear();
    let month = dt.getMonth();

    let fulltable = [];
    let day   = 1
    let state = new Date(year, month, day);
    while (state.getMonth() == month) {
      fulltable.push(this.getMoonPhase(state));
      day++;
      state = new Date(year, month, day);
    }

    return fulltable;
  }

}
